import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, UserPlus, ArrowRight } from "lucide-react";
import { useGlobal } from "../../context/GlobalContext";
import { images } from "../../assets/images";
import storage from "../../assets/js/Global";

const NewChatList = () => {
  const { employeeList, getEmployeeList, createChatRoom } = useGlobal();
  const [search, setSearch] = useState("");

  useEffect(() => {
    getEmployeeList(search);
  }, [getEmployeeList, search]);

  const navigate = useNavigate();

  return (
    <div className="web-chat-container">
      <div className="chat-sidebar">
        <div className="sidebar-header">
          <div className="form-group position-relative">
            <Search
              className="position-absolute text-muted"
              size={18}
              style={{
                left: "14px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
            <input
              type="text"
              className="form-control border-0 bg-light rounded-pill fs-15 input-tags"
              style={{ paddingLeft: "42px", height: "48px" }}
              placeholder="Search people..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        <div className="chat-list-scroll">
          {employeeList.length > 0 ? (
            employeeList?.map((u) => {
              const name = `${u.first_name} ${u.last_name}`;
              const avatar = u.profile_img || images.userAvatar;

              return (
                <div
                  key={u.user_pid}
                  className="web-chat-item"
                  onClick={async () => {
                    let roomData = null;

                    if (u.room_pid) {
                      roomData = {
                        room_pid: u.room_pid,
                        employee: u,
                      };
                    } else {
                      const room = await createChatRoom(u.user_pid);
                      if (!room) return;
                      roomData = room;
                    }
                    storage.set("selectedRoom", roomData);
                    storage.set("selectedUser", u);
                    navigate("/chats", {
                      state: {
                        room: roomData,
                        user: u,
                      },
                    });
                  }}
                >
                  <div className="position-relative">
                    <img
                      src={avatar}
                      alt={name}
                      className="chat-avatar-lg"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = images.userAvatar;
                      }}
                    />
                  </div>

                  <div className="chat-info-block ps-1">
                    <span className="chat-user-name mb-0">{name}</span>
                    <span className="text-secondary fs-12 fw-bold opacity-75">
                      {u.role || u.user_type?.label}
                    </span>
                  </div>

                  <div className="chat-meta-info">
                    <ArrowRight size={18} className="text-muted opacity-50" />
                  </div>
                </div>
              );
            })
          ) : (
            <p className="text-muted text-center mt-3">No users found</p>
          )}
        </div>
      </div>

      <div className="chat-main-area d-none d-md-flex align-items-center justify-content-center bg-white">
        <div className="text-center p-5 animate-bounce-in">
          <div
            className="p-4 rounded-circle d-inline-block mb-4"
            style={{ background: "#0d6efd1a" }}
          >
            <UserPlus size={48} className="text-primary" />
          </div>
          <h3 className="fw-extrabold text-dark mb-2">Start a New Chat</h3>
          <p className="text-muted fs-15 mb-4">
            Search for users and select someone to start
            <br />a direct message or team collaboration.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NewChatList;
